import React from "react";
import { Route, Link } from "react-router-dom";

export default function NavLink({ children, to, exact, location, props }) {
  return (
    <Route
      path={to}
      exact={exact}
      children={({ match }) => (
        <li className={match && "active"} >
              <Link to={`${to}`} search={location.search} {...props}>
            <span> {children}</span>
          </Link>
        </li>
      )}
    />
  );
}
